window.com = {};
com.maddenmascot = {};

// End point
com.maddenmascot.endpoint = {
  local: '//localhost:8080',
  public: 'https://api.maddenmascot.com',
  ngrok: 'https://ef7394b8.ngrok.io',
  currentEndPoint: 'public',
  getCurrentEndPoint: function () {
    return this[this.currentEndPoint];
  }
};

com.maddenmascot.utils = {
  roundNumber: function(num, digits) {
    var si = [
      { value: 1E18, symbol: "E" },
      { value: 1E15, symbol: "P" },
      { value: 1E12, symbol: "T" },
      { value: 1E9,  symbol: "G" },
      { value: 1E6,  symbol: "M" },
      { value: 1E3,  symbol: "k" }
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
    for (i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
      }
    }
    return num.toFixed(digits).replace(rx, "$1");
  },
  redirectToUrlWithQueryString: function (url, objParams) {
    var final = url + '?' + jQuery.param(objParams);
    window.location.href = final;
  },
  getUrlParams: function () {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  },
  getParameterByName: function(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  },
  getConsoleName: function(id){
    switch(id){
      case 4:
        return "Playstation 4";
        break;
      case 5:
        return "Xbox One";
        break;
      case 6:
        return "iOS";
        break;
      case 7:
        return "Android";
        break;
      default:
        return "-1";
        break;
    }
  },
  showError: function (aTitle, aDescription, callback) {
      window.dispatchEvent(com.maddenmascot.customer.loadErrorEvent);
      if (callback) {
        swal(
          {
            title: aTitle,
            text: aDescription,
            type: "error"
          },
          function () {
            callback();
          }
        );
      } else {
        swal(aTitle, aDescription, "error");
      }
    },
    showSuccess: function (aTitle, aDescription, callback) {
      window.dispatchEvent(com.maddenmascot.customer.loadSuccessEvent);
      if (callback) {
        swal(
          {
            title: aTitle,
            text: aDescription,
            type: "success"
          },
          function () {
            callback();
          }
        );
      } else {
        swal(aTitle, aDescription, "success");
      }
    },
    createPlayerHtml: function(player, classAnimated) {
      var tier = player.color,
          rating = player.rating,
          team = player.teamAbbreviation.toLowerCase(),
          position = player.position,
          chemistries = player.chemistries,
          programName = player.program.name.toLowerCase().replace(" ", "-"),
          programImage = player.program.image,
          firstName = player.firstName,
          lastName = player.lastName,
          capHit = player.capHit,
          playerImage = player.playerImage,
          player = '';

                '' + ''
      player += '<li class="pack-slot ' + (classAnimated ? classAnimated : '') +  ' m17 t-'+tier+' ' + (tier>3 ? 'shake': '') + '">'+
                  '<div class="card-back"></div>'+
                  '<a><div class="mut-item m17 t'+tier+'">'+
                    '<div class="right-bar">'+
                    '<span class="overall">' + rating + '</span> <span class="team-logo ' + team + '"></span> <span class="position">' + position + '</span>';
      if (chemistries && chemistries.length > 0){
        player +=   '<ul class="chemistries">';
        for (var i = 0; i<chemistries.length; i++){
          var chemistry = chemistries[i];
          player +=   '<li class="tip" title="' + (chemistry.flavorText || '') + '"><img src="' + chemistry.image + '"></li>';
        }
        player +=   '</ul>';
      }              
        player +=   '</div><img class="program-icon '+programName+'" src="'+programImage+'">'+
                    '<div class="name">' +
                      '<span class="first-name">' + firstName +'</span> <span class="last-name">' + lastName + '</span>' +
                    '</div>' +
                    '<div class="card-clipper">' +
                      '<span class="cap-hit">' + capHit + '</span>' +
                      '<div class="card-background" style="background-image: url('+playerImage+');"></div>'+
                    '</div>' +
                  '</div></a>' +
                '</li>';

     return player;
    },
    // Indicates that an ajax call is about to start
    ajaxCallStartedEvent: new Event('ajaxCallStarted'),

    // Indicates that an ajaz call just ended
    ajaxCallEndedEvent: new Event('ajaxCallEnded')
};

CoreUtils = {
  roundNumber: function(num, digits) {
    var si = [
      { value: 1E18, symbol: "E" },
      { value: 1E15, symbol: "P" },
      { value: 1E12, symbol: "T" },
      { value: 1E9,  symbol: "G" },
      { value: 1E6,  symbol: "M" },
      { value: 1E3,  symbol: "k" }
    ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
    for (i = 0; i < si.length; i++) {
      if (num >= si[i].value) {
        return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
      }
    }
    return num.toFixed(digits).replace(rx, "$1");
  },
  getUrlParams: function() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
  }
}

// custom component for input number
window.inputNumber = function(el, fn, optMax) {
  var min = el.attr('min') || false;
  var step = el.attr('step');
  var els = {};
  els.dec = el.prev();
  els.inc = el.next();
  
  if (!max) { var max = optMax; }

  el.each(function() {
    init($(this));
  });

  function init(el) {
    els.dec.on('click', decrement);
    els.inc.on('click', increment);
    function decrement() {
      var value = el[0].value;
      value = parseInt(value) - parseInt(step);
      if(!min || value >= min) {
        el[0].value = value;
        if (fn) {
          fn(value);
        } else {
          numberChange(value);
        }
      }
    }
    function increment() {
      var value = el[0].value;
      value = parseInt(value) + parseInt(step);
      if(!max || value <= max) {
        el[0].value = value++;
        if (fn) {
          fn(value);
        } else {
          numberChange(value);
        }
      }
    }
  }
}
